export const removeDuplicateTableCells = () => {
    const offerTables = document.querySelectorAll(".offer-table--origin .offer-table__offers");
    if (window.innerWidth < 768) {
        return;
    }
    if(offerTables === 'undefined' || offerTables.length < 1) {
        return false;
    }
    
    offerTables.forEach(currentTable => {
        if(currentTable.classList.contains('offer-table__offers--removed-duplicates')) {
            return;
        }
        const tableItemRows = currentTable.querySelectorAll(".offers-item-row");

        tableItemRows.forEach((currentItemRow) => {
            const rowItems = currentItemRow.querySelectorAll(".offer-item");
            
            for (let i = 0; i < rowItems.length; i++) {
                for (let j = i; j < rowItems.length-1; j++) {
                    const currentItemContent = rowItems[j];
                    const nextItemContent = rowItems[j+1];

                    if (currentItemContent.innerHTML === nextItemContent.innerHTML) {
                        nextItemContent.classList.add("duplicate-item");
                    }
                }
            }
        })

        tableItemRows.forEach((currentItemRow) => {
          const duplicateItems = currentItemRow.querySelectorAll('.duplicate-item');

          switch(duplicateItems.length) {
              case 0:
                  break;
              case 1:
                  duplicateItems[0].previousSibling.classList.add("offer-item--two-column-width");
                  break;
              case 2:
                  duplicateItems[0].previousSibling.classList.add("offer-item--three-column-width");
                  break;
              default:
                  break;
          }
        });

        currentTable.classList.add('offer-table__offers--removed-duplicates');
    });
  }